const nodeList = new Map()

const createHandler = (el, binding) => {
  const handler = {
    excludeElements: null,
    touchStartTarget: null,
    getExcludeElements() {
      const excludes = [el]
      if (binding.value?.exclude) {
        const elements = Array.isArray(binding.value.exclude)
          ? binding.value.exclude
          : [binding.value.exclude]
        elements.forEach(item => {
          if (item?.$el) excludes.push(item.$el)
          else if (item instanceof HTMLElement) excludes.push(item)
          else if (typeof item === 'string') {
            const dom = document.querySelector(item)
            dom && excludes.push(dom)
          }
        })
      }
      return excludes
    },
    onTouchStart(e) {
      this.touchStartTarget = e.touches[0]
        ? document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
        : null
      this.excludeElements = this.getExcludeElements()
    },
    onTouchEnd(e) {
      if (!this.touchStartTarget || !this.excludeElements) return
      const touchEndTarget = e.changedTouches[0]
        ? document.elementFromPoint(
            e.changedTouches[0].clientX,
            e.changedTouches[0].clientY
          )
        : null
      if (!touchEndTarget) return
      const isOutside = !this.excludeElements.some(
        item =>
          item.contains(this.touchStartTarget) || item.contains(touchEndTarget)
      )
      if (isOutside) {
        const handler =
          typeof binding.value === 'function'
            ? binding.value
            : binding.value?.handler
        handler?.(e)
      }
      this.touchStartTarget = null
      this.excludeElements = null
    },
  }

  handler.onTouchStart = handler.onTouchStart.bind(handler)
  handler.onTouchEnd = handler.onTouchEnd.bind(handler)
  return handler
}

const removeHandler = el => {
  const handler = nodeList.get(el)
  if (handler) {
    document.removeEventListener('touchstart', handler.onTouchStart)
    document.removeEventListener('touchend', handler.onTouchEnd)
    nodeList.delete(el)
  }
}

export default {
  bind(el, binding) {
    const handler = createHandler(el, binding)
    nodeList.set(el, handler)
    document.addEventListener('touchstart', handler.onTouchStart, {
      passive: true,
    })
    document.addEventListener('touchend', handler.onTouchEnd)
  },

  update(el, binding) {
    removeHandler(el)
    const handler = createHandler(el, binding)
    nodeList.set(el, handler)
    document.addEventListener('touchstart', handler.onTouchStart, {
      passive: true,
    })
    document.addEventListener('touchend', handler.onTouchEnd)
  },

  unbind: removeHandler,
}
